import { defineMessages } from 'react-intl';

export default defineMessages({
  contentCrateLoading: {
    id: 'shared.contentCrateLoading.title',
    defaultMessage: 'Loading content... (steaming coffee cup)',
    description:
      'Label describing a loading animation for the primary page content',
  },
  loadingSuccessful: {
    id: 'shared.loadingSuccessful.label',
    defaultMessage: 'Loading successful',
    description: 'Label describing loading page successful',
  },
});
